import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

let _selectedLayerName;

const init = function () {
	_selectedLayerName = $("#master-common-layer").data("layerselected") || null;
	const $banner = $("#js-login-hint-banner");
	$banner.on("click", () => {
		OcmMessenger.publish(messengerPublicationTypes.REQUEST_LOGIN, {
			selectedLayerName: _selectedLayerName,
			isClosable: true,
		});
	});
};

export { init };
